import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { HOME } from "../../constants/labels";
import "./UserDetails.scss";

const UserDetails = () => {
  const userName = useSelector((state) => state.header.userName);
	console.log(": UserDetails -> userName", userName);
  return (
    <Grid container spacing={2}>
      <Box className="user-detail">
        <Typography
          variant="h5"
          className="user-name"
        >
          {HOME.WELCOME} {userName}
        </Typography>
      </Box>
    </Grid>
  );
};

export default UserDetails;
